@switch (SITE_TYPE_VALUE) {
  @case (SITE_TYPE.LOCAL) {
    <span class="mg-r-5">
      <i class="fas fa-map-marker site-icon-local"></i> {{ siteLibelle }}
    </span>
  }
  @case (SITE_TYPE.REFERENT) {
    <span class="mg-r-5">
      <i class="fas fa-map-marker site-icon-referent"></i> {{ siteLibelle }}
    </span>
  }
  @case (SITE_TYPE.NONE) {
    <span class="mg-r-5">
      <i
        class="fas fa-map-marker"></i> {{ siteLibelle }}
    </span>
  }
}
